import { FC, useContext } from 'react';

import { Label } from '@smartshell/ui-kit';
import dayjs from 'dayjs';

import { FeaturesContext } from 'features';
import { LocalizationContext } from 'localization';

import { ISubscriptionLabelProps } from './interfaces';
import { getSubscriptionColor } from './utils';

export const SubscriptionLabel: FC<ISubscriptionLabelProps> = ({
  variant = 'subscription',
  clubSubscription,
}) => {
  const { t } = useContext(LocalizationContext);
  const { subscription, expiresAt } = useContext(FeaturesContext);

  const currentExpiresAt =
    variant === 'clubCard' ? undefined : dayjs(expiresAt);
  const currentSubscription =
    variant === 'clubCard' ? clubSubscription : subscription;

  if (!currentSubscription) return null;

  if (currentExpiresAt && currentExpiresAt.diff(dayjs(), 'days') <= 14) {
    return (
      <Label
        dataTestId="subscription-expires"
        text={t('subscription.expires')}
        color="orange"
        rounded
      />
    );
  }

  if (variant === 'status') {
    if (!currentExpiresAt) return null;

    if (currentExpiresAt.diff(dayjs(), 'days') <= 14) {
      return (
        <Label
          dataTestId="subscription-expires"
          text={t('subscription.expires')}
          color="orange"
          rounded
        />
      );
    }

    return (
      <Label
        dataTestId="subscription-active"
        text={t('subscription.active')}
        color="green"
        rounded
      />
    );
  }

  return (
    <Label
      dataTestId="subscription"
      text={currentSubscription}
      color={getSubscriptionColor(currentSubscription)}
      rounded
      size="m"
    />
  );
};
